function flitersOpen() {
    var filterSearch = document.getElementById("ais-filters-container");
    var btnfilterSearch = document.querySelector(".ais-filter-select");
    filterSearch.classList.toggle('ais-filters-toggle');
    filterSearch.removeAttribute('style');
    btnfilterSearch.classList.toggle('ais-filter-select--active');
}




$(document).mouseup(function(e) {
    var container = $(".ais-search-header");
    var containerFilter = $("#ais-filters-container");
    var btncontainerFilter = $(".ais-filter-select");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        containerFilter.attr('style', 'display: none !important');
        containerFilter.removeClass('ais-filters-toggle');
        btncontainerFilter.removeClass('ais-filter-select--active');
    }
});